


















import { Component, Prop, Mixins } from "vue-property-decorator";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

@Component
export default class CProdAboutComponent extends Mixins(CProdInjectorMixin) {
  // Props
  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;
  // Computed
  public get isVisible() {
    return !!this.cProdData.description?.length;
  }
}
